import { Link } from 'react-router-dom'
import { Button } from '@/components/ui'
import { Home, ArrowLeft } from 'lucide-react'

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6">
      <div className="space-y-2">
        <h1 className="text-6xl font-bold text-primary glow-text">404</h1>
        <p className="text-xl text-muted-foreground">Page not found</p>
      </div>

      <div className="font-mono text-sm text-muted-foreground space-y-1">
        <p><span className="text-primary">{'>'}</span> Error: ENOENT</p>
        <p><span className="text-primary">{'>'}</span> The requested resource could not be located</p>
        <p><span className="text-primary">{'>'}</span> Please check the URL and try again</p>
      </div>

      <div className="flex gap-4">
        <Button variant="outline" onClick={() => window.history.back()}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Go Back
        </Button>
        <Link to="/">
          <Button>
            <Home className="mr-2 h-4 w-4" />
            Home
          </Button>
        </Link>
      </div>
    </div>
  )
}
